<template>
  <info-banner
    :text="this.$t('ButtonCloseGenerator.close') + '<span>Elektramat</span>'"
    class="banner-close-generator light-blue fixed"
    :confirm-text="
      this.$t('ButtonCloseGenerator.leave_warning') +
      '<br>' +
      this.$t('ButtonCloseGenerator.are_you_sure_leave')
    "
    href="/"
  >
    <template #left-content>
      <img :src="getIcon('triangle.svg')" alt="" />
    </template>
  </info-banner>
</template>

<script>
import InfoBanner from './InfoBanner';

export default {
  name: 'ButtonCloseGenerator',

  components: { InfoBanner },
};
</script>
